<template>
  <section id="section-2" class="content-current">
    <div class="row">
      <div class="col-md-12">
        <div>
          <input id="upload-img" type="file" ref="file" accept=".jpeg,.jpg,.png,.tiff,.pdf" @change="onFileChange"
            style="display: none" />
        </div>
      </div>
      <div class="col-md-2 img-icon"></div>
    </div>

    <div style="text-align: center" class="col-md-12 loading" v-if="isLoading">
      <loadingBar type="ripple" />
    </div>
    <div v-else>
      <div class="table-responsive">
        <table class="table tablesorter add_bottom_30">
          <thead class="thead-light">
            <tr>
              <th colspan="10">نام فایل</th>
              <th colspan="7">نوع</th>
              <th colspan="7">وضعیت</th>
              <th colspan="7">آپلود / حذف / نمایش</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(file, index) in files" :key="file.id">
              <td colspan="10">{{ file.name }}</td>

              <td colspan="7">
                <div class="select">
                  <select class="select-text" v-model="file.uploadedType">
                    <option v-for="item in uploadedTypeItems" :value="item.key" :key="item.key">
                      {{ item.value }}
                    </option>
                  </select>

                  <span class="select-highlight"></span>
                  <span class="select-bar"></span>

                  <label class="select-label"><span class="validation-color">*</span>نوع</label>

                </div>
              </td>
              <td colspan="7">{{ getStatus(file.status) }}</td>
              <td>
                <button v-if="file.id === undefined" @click="UpdateFiles(file, index)"
                  class="btn btn-primary attach-btn" style="">
                  آپلود
                </button>
                <button v-else class="btn btn-primary attach-btn" style="background: #7cb1ef">
                  آپلود
                </button>
                <button v-else class="btn btn-primaryattach-btn" style="background: #7cb1ef">
                  آپلود
                </button>
                <i v-if="file.status !== 3" style="font-size: 20px !important; cursor: pointer"
                  class="icon-trash-2 remove" @click.prevent="remove(index)"></i>
                <i v-else style="
                    font-size: 20px !important;
                    cursor: pointer;
                    color: #e68282 !important;
                  " class="icon-trash-2 remove"></i>

                <i class="icon-eye-1" style="
                    cursor: pointer;
                    color: rgb(124 177 239);
                    font-size: 20px;
                  " v-if="file.id === undefined"></i>

                <i v-else @click="showDoc(file)" style="cursor: pointer; color: #08446a; font-size: 20px"
                  class="icon-eye-1"></i>
                <i @click="showErrorDescription(file)" style="
                    cursor: pointer;
                    color: rgb(252 102 58);
                    font-size: 20px;
                  " v-if="file.status === 2" class="icon-warning-empty"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="btn-align">
        <label for="upload-img">
          <div class="btn btn-primary" style="padding-top: 10px">انتخاب فایل</div>
        </label>

        <button type="submit" class="btn btn-danger" @click.prevent="goBackToList">
          بازگشت
        </button>
      </div>
    </div>
    <!--remove modal -->
    <transition name="modal" v-if="showDeleteConfirm">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-body"></div>
            <p style="font-size: 15px">آیا از حذف اطمینان دارید؟</p>
            <div class="custom-footer modal-footer">
              <button style="background: red" class="btn btn-danger modal-btn" @click="removeDoc">
                بله
              </button>
              <button class="btn-profile modal-btn" @click="showDeleteConfirm = !showDeleteConfirm">
                خیر
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!--error descriptio modal -->
    <transition name="modal" v-if="showError">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-body"></div>
            {{ errorDescription }}
            <div class="custom-footer modal-footer">
              <button class="btn btn-primary modal-btn" @click="showError = !showError">
                بستن
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>


<script>
import uri from "../../../public/publicUries";
import loadingBar from "../../components/loading/pdkLoadingBar";

export default {
  components: { loadingBar },
  data() {
    return {
      profileId: "",
      files: [],
      isEditMode: false,
      checkIndex: 1,
      imageAddress: "",
      showDeleteConfirm: false,
      selectedIndex: -1,
      isLoading: false,
      uploadedTypeItems: [
        { key: 1, value: "مجوز الف یا ب" },
        { key: 2, value: "کارت شناسائی مدیریت" },
        { key: 3, value: "روزنامه رسمی" },
        { key: 4, value: "سایر" },
      ],
      documentId: 0,
      showError: false,
      errorDescription: "",
    };
  },
  mounted() {
    this.getUserId();
  },

  methods: {
    async getUserId() {
      await this.$store.dispatch("getUserId").then(() => {
        this.profileId = this.$store.getters.GetProfileId;
        this.fetchData();
      });
    },
    fetchData() {
      this.isLoading = true;
      this.$store
        .dispatch("getDocumnetsByProfileId", this.profileId)
        .then((res) => {
          if (res.length != 0) {
            this.isEditMode = true;
            this.files = res;
          }
        });
      this.isLoading = false;
    },
    onFileChange() {
      for (var i = 0; i < this.$refs.file.files.length; i++) {
        if (
          this.$refs.file.files[i].type === "image/jpeg" ||
          this.$refs.file.files[i].type === "image/jpg" ||
          this.$refs.file.files[i].type === "image/png" ||
          this.$refs.file.files[i].type === "image/tiff" ||
          this.$refs.file.files[i].type === "application/pdf"
        ) {
          this.files.push(this.$refs.file.files[i]);
        } else {
          // alert("فرمت فابل معتبر نمی باشد!!!");
          this.$toast.error("فرمت فابل معتبر نمی باشد!!!", {
            position: "top-center",
            timeout: 4500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 1.59,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            icon: true,
            rtl: true,
          });
          return;
        }
      }
    },
    remove(index) {
      this.selectedIndex = index;
      this.showDeleteConfirm = true;
    },
    async removeDoc() {
      if (this.files[this.selectedIndex] != null) {
        let deleted = this.files[this.selectedIndex];
        this.files.splice(this.selectedIndex, 1);
        this.showDeleteConfirm = false;

        if (deleted.id !== undefined) {
          const data = {
            id: deleted.id,
          };
          const res = await this.$store.dispatch("deleteDocument", data);
        }
      }
    },
    UpdateFiles(file) {
      this.isLoading = true;
      let formData = new FormData();

      formData.append("files", file);

      if (file.uploadedType == undefined) {
        // alert("لطفا نوع فایل را مشخص نمائید ");
        this.$toast.error("لطفا نوع فایل را مشخص نمائید ", {
          position: "top-center",
          timeout: 4500,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 1.59,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          icon: true,
          rtl: true,
        });
        this.isLoading = false;
        return;
      }
      formData.append("UploadedType", file.uploadedType);
      formData.append("ProfileId", this.profileId);
      // formData.append("DodumentId", file.id);

      this.$store.dispatch("UpdateUploadFiles", formData).then((res) => {
        if (res.status === 200) {
          this.fetchData();
          // alert("بروز رسانی مدارک با موفقیت انجام شد.");
          this.$toast.success("بروز رسانی مدارک با موفقیت انجام شد.", {
            position: "top-center",
            timeout: 4500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 1.59,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            icon: true,
            rtl: true,
          });
          this.isLoading = false;
        } else {
          // alert("بروز رسانی مدارک با خطا مواجه شد!!!!!");
          this.$toast.error("بروز رسانی مدارک با خطا مواجه شد!!!!!", {
            position: "top-center",
            timeout: 4500,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 1.59,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            icon: true,
            rtl: true,
          });
          this.isLoading = false;
        }
      });
    },

    onChange(index) {
      this.checkIndex = index;
    },
    getType(val) {
      if (typeof val != "number") return val;
      if (val == 1) return "image/png";
      if (val == 2) return "image/jpeg";
      if (val == 3) return "text/plain";
      if (val == 4) return "application/pdf";
      if (val == 5)
        return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (val == 6)
        return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      else return "نامشخص";
    },
    getStatus(val) {
      if (val == 1) return "در حال بررسی";
      if (val == 2) return "تائید نشده";
      if (val == 3) return "تائید شده";
    },
    showDoc(file) {
      const path =
        uri.documentUrl +
        this.profileId +
        "/" +
        this.profileId +
        "_" +
        file.name;
      window.open(path);
    },
    showErrorDescription(val) {
      this.showError = true;
      this.errorDescription = val.description;
    },
    goBackToList() {
      this.$router.push({ name: "userBusinessList" });
    },
  },
};
</script>

<style scoped>
.btn-profile.doc {
  background-color: #2a69b1;
}

th,
td {
  border-bottom: 1px solid #ddd !important;
  height: 70px;
  height: 70px;
}

thead {
  background-color: #ffff !important;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(0 0 0 / 39%);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.custom-footer {
  padding: 18px 5px 2px 5px !important;
}

.modal-container {
  width: 450px;
  margin: 0px auto;
  padding: 10px 10px;
  background-color: #fff;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 0px 10px;
}

.modal-default-button {
  float: right;
  width: auto !important;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-btn {
  width: 50px !important;
  height: 30px !important;
  padding: 0px !important;
  font-size: 12px;
}

.attach-btn {
  text-align: cenght;
  background: #3485e2;
  padding: 0px;
}
</style>
